const state = {
  selectedState: "",
  selectedCity: "",
  deliveryOptions: [],
  selectedDeliveryOption: null, // Armazena a opção de frete selecionada
  shippingCost: null,
  estados: [],
  cities: [],
  loading: false,
  errorMessage: "",
};

const mutations = {
  SET_SELECTED_STATE(state, payload) {
    state.selectedState = payload;
  },
  SET_SELECTED_CITY(state, payload) {
    state.selectedCity = payload;
  },
  SET_DELIVERY_OPTIONS(state, payload) {
    state.deliveryOptions = payload;
  },
  SET_SELECTED_DELIVERY_OPTION(state, payload) {
    state.selectedDeliveryOption = payload;
  },
  SET_SHIPPING_COST(state, payload) {
    state.shippingCost = payload;
  },
  SET_ESTADOS(state, payload) {
    state.estados = payload;
  },
  SET_CITIES(state, payload) {
    state.cities = payload;
  },
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  SET_ERROR_MESSAGE(state, payload) {
    state.errorMessage = payload;
  },
};

const actions = {
  updateSelectedState({ commit, dispatch }, payload) {
    commit("SET_SELECTED_STATE", payload);
    dispatch("updateCities"); 
  },
  updateSelectedCity({ commit }, payload) {
    commit("SET_SELECTED_CITY", payload);
  },
  updateDeliveryOptions({ commit }, payload) {
    commit("SET_DELIVERY_OPTIONS", payload);
  },
  updateSelectedDeliveryOption({ commit }, payload) {
    commit("SET_SELECTED_DELIVERY_OPTION", payload);
  },
  updateShippingCost({ commit }, payload) {
    commit("SET_SHIPPING_COST", payload);
  },
  updateCities({ commit, state }) {
    const selectedEstado = state.estados.find(estado => estado.estado_id === parseInt(state.selectedState, 10));
    commit("SET_CITIES", selectedEstado ? selectedEstado.cidades : []);
    commit("SET_SELECTED_CITY", ""); 
  },
  async calculateShipping({ commit, state, rootState }) {
    commit("SET_ERROR_MESSAGE", "");
    commit("SET_LOADING", true);

    if (!rootState.cart?.external_id) {
      setTimeout(() => this.dispatch("shipping/calculateShipping"), 2000);
      return;
    }

    if (!state.selectedCity || !rootState.cart || rootState.cart.itens.length === 0) {
      commit("SET_ERROR_MESSAGE", "Selecione uma cidade e tenha itens no carrinho!");
      commit("SET_LOADING", false);
      return;
    }

    try {
      const { shippingCost, deliveryOptions } = await calculateShipping(
        rootState.cart,
        state.selectedCity,
        state.selectedStateName,
        rootState.auth.user
      );

      commit("SET_DELIVERY_OPTIONS", deliveryOptions);
      commit("SET_SHIPPING_COST", shippingCost);

      const savedShippingDetails = JSON.parse(localStorage.getItem("selectedShippingDetails") || {});
      const selectedOption = deliveryOptions.find(
        option =>
          option.entrega_integrador_id === savedShippingDetails.entrega_integrador_id &&
          option.entrega_servico_id === savedShippingDetails.entrega_servico_id
      );

      if (selectedOption) {
        commit("SET_SELECTED_DELIVERY_OPTION", selectedOption);
        commit("SET_SHIPPING_COST", selectedOption.valor || 0);
      } else {
        const fallbackOption = deliveryOptions[0] || { entrega_servico_id: "retirada_loja", valor: 0 };
        commit("SET_SELECTED_DELIVERY_OPTION", fallbackOption);
        commit("SET_SHIPPING_COST", fallbackOption.valor || 0);
      }

      const shippingDetails = {
        estado: state.selectedStateName,
        cidade: state.selectedCityName,
        frete: state.shippingCost,
        deliveryOptions: state.deliveryOptions,
        selectedDeliveryOption: state.selectedDeliveryOption,
        entrega_integrador_id: state.selectedDeliveryOption?.entrega_integrador_id,
        entrega_servico_id: state.selectedDeliveryOption?.entrega_servico_id,
      };
      localStorage.setItem("selectedShippingDetails", JSON.stringify(shippingDetails));
    } catch (error) {
      commit("SET_ERROR_MESSAGE", "Erro ao calcular frete");
      console.error("Erro ao calcular frete:", error);
    } finally {
      commit("SET_LOADING", false);
    }
  },
  loadSavedShippingDetails({ commit, state }) {
    const savedShippingDetails = JSON.parse(localStorage.getItem("selectedShippingDetails") || {});

    if (savedShippingDetails.selectedState) {
      commit("SET_SELECTED_STATE", savedShippingDetails.selectedState);
    }
    if (savedShippingDetails.selectedCity) {
      commit("SET_SELECTED_CITY", savedShippingDetails.selectedCity);
    }
    if (savedShippingDetails.deliveryOptions) {
      commit("SET_DELIVERY_OPTIONS", savedShippingDetails.deliveryOptions);
    }
    if (savedShippingDetails.selectedDeliveryOption) {
      commit("SET_SELECTED_DELIVERY_OPTION", savedShippingDetails.selectedDeliveryOption);
    }
    if (savedShippingDetails.frete) {
      commit("SET_SHIPPING_COST", savedShippingDetails.frete);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};